import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@mui/joy';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import './LeaveTypeFormStyle.css';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import { TbFileDescription } from 'react-icons/tb';
import CustomTextArea from '../../../../Components/custom_components/CustomTextArea/CustomTextArea';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { statusOptions } from '../../../../utils/constants'
import CustomCheckbox from '../../../../Components/custom_components/CustomCheckbox/CustomCheckbox';

function LeaveTypeForm({ handleLeaveTypeSave, isButtonDisabled, formIntialValues, id }) {

    const formik = useFormik({
        initialValues: formIntialValues, // Set initial values directly from props
        validationSchema: Yup.object({
            Name: Yup.string().required('Leave type name is required'),
            status: Yup.string().required('Status is required'),
        }),
        enableReinitialize: true, // Enable re-initialization of form values when props change
        onSubmit: (values) => {
            handleLeaveTypeSave(values, id);
        },
    });

    // Reset handler
    const handleReset = () => {
        formik.setFieldValue('status', 1);
        formik.setFieldValue('Name', '');
        formik.setFieldValue('Description', '');
        formik.setFieldValue("is_cof", 1);
        // Reset warning messages
        formik.setTouched({
            Name: false,
            status: false,
            Description: false
        });
    };


    return (
        <div className='leave-type-form-container'>
            {/* FORM START */}
            <Grid container spacing={2}>

                {/* checkbox */}
                <Grid item xs={12} mb={6} sx={{ m: 0 }}>
                    <CustomCheckbox
                        label="COF (Compensatory Off)"
                        checked={formik.values.is_cof === 2} //2 means cof true    
                        onChange={(e) =>
                            formik.setFieldValue("is_cof", e.target.checked ? 2 : 1)
                        }
                    />
                </Grid>

                {/* LEFT SIDE */}
                <Grid item xs={12} md={6}>
                    <div className='leave-type-form-mid-container'>
                        <div className='leave-type-label-container'>
                            <span className='leave-type-label'>
                                Leave Type Name <span className='leave-type-required-remark'>*</span>
                            </span>
                        </div>
                        <div className='leave-type-custom-textfield-container'>
                            <CustomTextFieldWithIcon
                                id='Name'
                                name='Name'
                                placeholder='Enter leave type name'
                                value={formik?.values?.Name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.Name && Boolean(formik.errors.Name)}
                                helperText={formik.touched.Name && formik.errors.Name}
                            />
                        </div>
                    </div>
                </Grid>

                {/* RIGHT SIDE */}
                {id && <Grid item xs={12} md={6}>
                    <div className='leave-type-form-mid-container'>
                        <div className='leave-type-label-container'>
                            <span className='leave-type-label'>
                                Status <span className='leave-type-required-remark'>*</span>
                            </span>
                        </div>
                        <div className='leave-type-custom-textfield-container'>
                            <CustomSelectDropdown
                                name="status"
                                placeholder="Select Status"
                                options={statusOptions}
                                value={statusOptions?.find(option => option?.value === formik?.values?.status) || ""}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("status", selectedOption ? selectedOption.value : "");
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.status && Boolean(formik.errors.status)}
                                helperText={formik.touched.status && formik.errors.status}
                                isClearable={false} // Set to false for single-select
                                width="100%"
                            />
                        </div>
                    </div>
                </Grid>
                }
                <Grid item xs={12} md={6}>
                    {/* LeaveTypeDescription */}
                    <div className="leave-type-label-container">
                        <span className="leave-type-label">Description</span>
                    </div>
                    <div className="leave-type-custom-textfield-container">
                        <CustomTextArea
                            id="Description"
                            name="Description"
                            placeholder="Enter leave type description"
                            value={formik.values.Description}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            rows={5}
                            StartIcon={TbFileDescription}
                        />
                    </div>
                </Grid>




            </Grid>

            <div className='leave-type-form-bottom-action-buttons-container'>
                <ActionButton onClick={handleReset} label='Reset'
                    btnType='outlined'
                />
                <ActionButton
                    onClick={() => formik.handleSubmit()}
                    btnDisable={isButtonDisabled}
                    label='Save'
                    btnType='primary'
                />
            </div>
        </div>
    );
}

export default LeaveTypeForm;
